import { useId, useState } from 'react';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, Typography } from '@mui/material';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { CIDADES_ATENDIDAS } from './cidadesAtendidas';

const CidadesAtendidasDropdown: React.FC = () => {
  const accessibility = useAccessibility();
  const [aberto, setAberto] = useState(false);
  const panelId = useId();

  return (
    <div className="transcricao-cidades-dropdown">
      <button
        type="button"
        className="transcricao-cidades-dropdown-trigger"
        style={accessibility.textStyleAccessibility}
        aria-expanded={aberto}
        aria-controls={panelId}
        onClick={() => setAberto((prev) => !prev)}
      >
        Ver cidades atendidas
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`transcricao-cidades-dropdown-chevron${aberto ? ' transcricao-cidades-dropdown-chevron--aberto' : ''}`}
        />
      </button>

      <Collapse in={aberto}>
        <div
          id={panelId}
          className="transcricao-cidades-dropdown-panel"
          style={accessibility.contrastBorderAccessibility}
        >
          <Typography
            className="transcricao-cidades-dropdown-texto"
            style={accessibility.textStyleAccessibility}
          >
            Solicitações neste canal são exclusivas para autorização de exames/procedimentos
            realizados em:{' '}
            <strong>Campinas, Artur Nogueira, Cosmópolis, Holambra, Hortolândia, Indaiatuba, Jaguariúna, Monte Mor, Paulínia, Santo Antônio de Posse, Sumaré, Valinhos e Vinhedo.</strong>
          </Typography>
          <Typography
            className="transcricao-cidades-dropdown-texto"
            style={accessibility.textStyleAccessibility}
          >
            <strong>Em outras cidades, solicite diretamente à Unimed da região.</strong>
          </Typography>
        </div>
      </Collapse>
    </div>
  );
};

export default CidadesAtendidasDropdown;
